export default "/img/articles/specialists.jpg"